// extracted by mini-css-extract-plugin
module.exports = {"SectionCompare":"SectionCompare_SectionCompare__qglhV"};